import { render } from "./sv-tag.vue?vue&type=template&id=2662b85e&scoped=true&ts=true"
import script from "./sv-tag.vue?vue&type=script&lang=ts"
export * from "./sv-tag.vue?vue&type=script&lang=ts"

import "./sv-tag.vue?vue&type=style&index=0&id=2662b85e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2662b85e"]])

export default __exports__